<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre11" id="pgepubid00017"><a class="calibre1" id="Chapter_5">CHAPTER V.</a></h3>
<h4 class="calibre9 sigil_not_in_toc" id="pgepubid00018">RIGHT AND WRONG.</h4>
<p class="calibre3">"So you have never blamed me for my long absence, Hermione!"</p>
<p class="calibre3">More than an hour had passed since Harvey's first sight of his young
cousin. Mr. Dalrymple, after taking a cup of tea, and declining cake,
had returned to the library, rather to Hermione's surprise. This was
usually his accessible hour, if callers chose to come. Three callers
did choose to come, and they stayed long, but Mr. Dalrymple failed
to reappear. Hermione acted hostess with ease and grace, introducing
her newly-arrived relative, dispensing tea, and keeping up
conversation, her sunny sweetness never for an instant eclipsed.</p>
<p class="calibre3">Harvey watched her in some wonder. He had not expected this
development as a result of her "rustic" training and retired life.
Perhaps the absence of self-consciousness surprised him most; she had
been such a "vain little puss," he told himself, at eleven; and then
he almost thought that a touch of girlish shyness at nineteen may be
prettier than too complete self-possession. Yet how could he wish
anything altered when the entire effect was so charming? And after
all, was there really no consciousness of others' very patent
admiration? Not a conceited consciousness, but a happy confidence
in being able to please everybody. If it were so, was that a blemish?</p>
<p class="calibre3">He did not trouble himself to help her much in the way of talk. These
people, Mr., Mrs., and Miss Dalton, from a neighbouring village,
were comparative new-comers, and not interesting to him, not half
so interesting as was Hermione. Harvey commonly followed his own
inclinations in the matter of making himself agreeable.</p>
<p class="calibre3">So he let the chit-chat flow on, sparkling on the part of Hermione,
and more or less ponderous on the part of the other three, only
putting in a few words here and there when politeness rendered the
exertion a necessity, and keeping his attention fixed on Hermione
without appearing to do so. The Daltons, who, though not brilliant
themselves, could appreciate brilliancy in another, found him
"gentlemanly, but tedious— a rather dull person for one who had
travelled so much, and not to be compared with that delightful old
Mr. Dalrymple."</p>
<p class="calibre3">Harvey cared not a whit whether they liked him or no. He was only
amused at the variety of subjects which Hermione had at command
for their entertainment. She really did not need his aid. Miss Dalton
was a busy Parish-worker, and seemed to own no ideas beyond Parish
work, so Hermione went the round of schools, districts, and cottages
with her, smilingly interested all the while. Mrs. Dalton was
literary and semi-scientific in her tastes, therefore Hermione
launched out into a little sea of recent publications and discoveries
for the elder lady's edification. Mr. Dalton was a dabbler
in political and controversial subjects, and Hermione gave her
opinion upon each suggested point in turn, not conceitedly or
disagreeably, but with a gentle decision, and perhaps a sense that
her opinion was not altogether to be despised. Harvey could not help
calling to mind Marjory's words, "We all look up to her!" Did Mr.
Dalton too "look up" to this young creature of nineteen? His manner
was most deferential.</p>
<p class="calibre3">At length the callers departed, and then it was that some observation
of Hermione's drew from him the above remark, "So you have never
blamed me for my long absence." He had not yet divulged to her
his "chief item of news," having avoided the subject while Mr.
Dalrymple was in the room, and having been since prevented by the
presence of strangers. Now the time had come for speaking out.</p>
<p class="calibre3">"I do not quite know," she answered, looking up with her sunshiny
eyes. Harvey wondered if those eyes ever could be sad or grave.
"Only perhaps sometimes, when my grandfather seemed so worried, and I
could not think what kept you away. But Marjory would not let me
blame you."</p>
<p class="calibre3">"Marjory must be a very charitable individual."</p>
<p class="calibre3">"I don't know that she is. She does not try to excuse everybody."</p>
<p class="calibre3">Harvey laughed. The idea of Marjory making excuses for him
was amusing.</p>
<p class="calibre3">"I am very much obliged to her," he said. "Seriously, however,
I ought perhaps to have run home once or twice, if only for a few
days, for my uncle's sake."</p>
<p class="calibre3">"Yes; I have always thought so," she said, with a curious touch
of rebuke which immediately put him on the defensive. "It is not
as if you had been really unable."</p>
<p class="calibre3">"That is hardly a question about which you can come to a decision,"
he said, somewhat nettled.</p>
<p class="calibre3">The blue eyes were grave enough now.</p>
<p class="calibre3">"I thought you asked what I had felt. Marjory has always insisted
that we could not understand, that you must have reasons of your own.
I have let her say so; but I am not sure. You see, I know the
circumstances. I know you are well off, so it is no question
of expense, and you have no actual ties keeping you abroad.
Very often you have been too far-away to get home easily, but from
Germany or Italy surely it was possible. I do think dear grandfather
has had a right to see you, at least sometimes. I think you have been
wrong."</p>
<p class="calibre3">She might have been a woman of thirty sitting in judgment on a boy
of ten, so gently resolute was the manner. It was hardly to be
expected that Harvey should succumb to her judgment, he being a man
of thirty-two, and she a mere girl under twenty. He was alike
too gentlemanly and too good-natured to show anger to a lady,
but considerable meaning underlay the brief response—</p>
<p class="calibre3">"You think so!"</p>
<p class="calibre3">"Unless, of course, you had reasons," pursued Hermione, as if willing
to hear what he had to say for himself.</p>
<p class="calibre3">"I had reasons, undoubtedly."</p>
<p class="calibre3">"But—" Hermione looked at him and hesitated. Was she going to demand
those reasons? "But you will stay now, Harvey—now that you
have come!"</p>
<p class="calibre3">"Two or three nights."</p>
<p class="calibre3">"Not more! After eight years!"</p>
<p class="calibre3">"Hardly possible, I am afraid. You know a great deal about me,
evidently—" there was a touch of irony here— "still you are not
quite acquainted with all the circumstances of the case. There
happens to be a lady in the question. I hope you are prepared
to congratulate me."</p>
<p class="calibre3">The sunshine flashed back, and in a moment Hermione was again all
winning loveliness.</p>
<p class="calibre3">"Are you going to be married? I am very glad. My grandfather will be
so delighted. He has often said lately that you ought to think about
marrying. Who is it? What is her name?"</p>
<p class="calibre3">"Julia."</p>
<p class="calibre3">"And how old?"</p>
<p class="calibre3">"Twenty-one."</p>
<p class="calibre3">"Is she like me?"</p>
<p class="calibre3">"Not in the least."</p>
<p class="calibre3">"Pretty?"</p>
<p class="calibre3">"That may be a matter of opinion."</p>
<p class="calibre3">"And her surname?"</p>
<p class="calibre3">"Dalrymple."</p>
<p class="calibre3">"How strange. Is she a distant cousin?"</p>
<p class="calibre3">"I am not aware that we have any cousins within an appreciable
distance. Her name is Dalrymple now. A month ago she was Julia
Pilchard."</p>
<p class="calibre3">"A month ago! But you cannot mean—it is not possible—you are not
married already!"</p>
<p class="calibre3">"Yes. So you see I have, after all, something of an 'actual tie'
abroad—so long as Julia remains there."</p>
<p class="calibre3">Hermione was silent. Her face was grave once more, with a gravity
amounting to severity. She sat upright, one hand lying over the other
on her knee. How very young she seemed! Yet Harvey, lounging in a
chair opposite with his air of gentlemanly insouciance, had an odd
"naughty-boy" sense of being called to account by her for his
misdoings. It was quite absurd. He positively almost dreaded her next
words, and found it difficult to wind himself up to a due
indifference.</p>
<p class="calibre3">"Julia is an orphan, like yourself," he said, hiding the feeling
of embarrassment under a light manner. "She has only one sister,
a widow, Mrs. Trevor, several years older than herself. I met them
in Algeria last autumn, travelling for the sake of Mr. Trevor's
health. Three months ago I came across them again in a Swiss hotel.
Mr. Trevor had died before Christmas."</p>
<p class="calibre3">No answer came. Had Hermione taken unknowingly a leaf out of her
grandfather's book? She seemed to be thinking deeply.</p>
<p class="calibre3">"Mrs. Trevor is a most charming person. You will be delighted
with her. They were both in great trouble when I found them
at Chamouni—not alone from the death of Mr. Trevor. Mrs. Trevor had
just heard of a lost lawsuit, which meant ruin to herself and her
child—and to Julia also. Julia was dependent on her."</p>
<p class="calibre3">Hermione spoke at last in a low voice of displeasure. "Married! And
without a word to my grandfather! Does he know?"</p>
<p class="calibre3">"I told him immediately. That was my object in coming here."</p>
<p class="calibre3">"But not till a month afterwards! And all the love and kindness
he has shown—Marjory will not try to defend this!"</p>
<p class="calibre3">"Marjory's opinion can be of no possible importance," said Harvey,
secretly irritated.</p>
<p class="calibre3">"Was that why he seemed so unlike himself when he brought you in?
Yes, of course—I see now. I did not understand. Harvey, you will
excuse me, please. I must go to him."</p>
<p class="calibre3">Harvey rose as Hermione stood up. "Remember," he said, "my uncle
claims no authority over me. He could not claim it rightly. Whether I
should have acted with greater wisdom in speaking to him earlier,
is a question about which there may be two opinions. You, not knowing
all the circumstances of the case, hold one view. I hold the other."</p>
<p class="calibre3">Hermione's eyes met his reproachfully. "Authority—no," she said. "But
he ought to have heard: he had a right to know. It was wrong not to
tell him. Nothing can alter that."</p>
<p class="calibre3">"In your opinion!"</p>
<p class="calibre3">"I cannot imagine any circumstances that would make me think
differently."</p>
<p class="calibre3">"Possibly not."</p>
<p class="calibre3">"Right is right, and wrong is wrong. Nothing can change wrong into
right."</p>
<p class="calibre3">"Nevertheless the question does occasionally arise—What is right,
and what is wrong?"</p>
<p class="calibre3">"It may always be answered."</p>
<p class="calibre3">"Not always with absolute certainty."</p>
<p class="calibre3">"Yes; there is never any real difficulty where one is determined
on doing the right. If one is merely bent on pleasing oneself—"</p>
<p class="calibre3">Harvey made a mocking bow.</p>
<p class="calibre3">"I am not jesting," she said, and the blue eyes, attractive in their
soft gravity, were again lifted to his. "It is a serious question,
not at all a matter for jesting. So much depends upon the way
in which we do things. You know very well that a thing right
in itself may be wrongly carried out."</p>
<p class="calibre3">The sweet incisive tones paused, for Mr. Dalrymple entered. He looked
pale still, yet it was with a smile that he came forward, and laid a
hand on the young man's shoulder. To Hermione's surprise there were
no tokens of displeasure in his bearing.</p>
<p class="calibre3">"I did not intend to stay so long," he said. "More than an hour,
is it not? I must have been asleep, I think. Slade announced callers,
but I told him I would rest. My head is strangely heavy this
afternoon as if thunder were near. Are you both inclined for a stroll
on the terrace. Not a ride to-day, Hermione—somehow I do not feel
equal to it. Besides, I must see the most of this dear fellow while
he is with us. Perhaps on Monday a ride all together will be
pleasant. He must renew his acquaintance with the country."</p>
<p class="calibre3">"Very pleasant," Harvey assented, privately wondering whether he
would find it possible to carry out his plan of two nights only at
Westford. If not, what would Julia say?</p>
<p class="calibre3">Hermione had drawn close to her grandfather, and was gazing wistfully
into his fine clear-cut face.</p>
<p class="calibre3">"You have taken good care of your cousin," he said to her.</p>
<p class="calibre3">"Yes," she answered slowly.</p>
<p class="calibre3">"Come, then. Have you a hat at hand? I shall like a little
fresh air."</p>
<p class="calibre3">The terrace, a broad gravel-walk with huge flowerpots along it
at intervals, bounded one side of the house, and ran then for some
distance round a lawn of green velvet, enriched by flower-beds.
The roses were in full luxuriance, showing every possible tint from
pure white to deep red-black; and geraniums bloomed in scarlet and
crimson masses.</p>
<p class="calibre3">Hermione held one of Mr. Dalrymple's arms, unwontedly silent, as he
paced the terrace. He too was still a little absent and dreaming,
though he pointed out his favourite plants from time to time to the
young man walking on his other side.</p>
<p class="calibre3">It might have been expected that the three would have had more to say
one to another after eight years' separation. Conversation languished
greatly. So long as Hermione declined to assist, Harvey's efforts
seemed to be useless.</p>
<p class="calibre3">He gave her a glance now and then, growing provoked as the minutes
went on. Evidently hers was a silence of judicial displeasure, acted
out as a duty. She was looking wonderfully pretty in her white dress
and straw hat, the summer sunshine lending brilliance to her pure
skin. But after all, what business had she to take him to task in
this fashion?—she, a mere child, only nineteen in age, two years
younger than his young wife. And what did Hermione know about the
matter? He could not of course explain to her the old man's intense
desire for that which never could be, and never could have been.</p>
<p class="calibre3">No, never! Harvey felt this now more than ever. Fascinating as
Hermione might be, formed by nature to reign over the hearts
of others, she would never have done for him, even if he had not met
with Julia. "Much too angelic and infallible a being for a lazy
fellow like me!" he thought, with an inward laugh, while gravely
responding to an observation of Mr. Dalrymple's; "The Baroness
Rothschild, yes, a particularly fine specimen—splendid bloom—if only
it had a scent."</p>
<p class="calibre3">But Hermione could not know of Mr. Dalrymple's long-cherished desire,
once plainly uttered to Harvey. And Harvey would not have cared
to admit even to himself, much less to anybody else, the undefined
sense of weakness, which had made him so dread the moral coercion
of a stronger nature and will than his own, that he had absolutely
stayed away all these years from the fear of it. Then, when at length
he was taken captive by Julia Pilchard, a half-cowardly dislike
to the worry of possible opposition had come into play, and he had
deferred speech until opposition should be useless.</p>
<p class="calibre3">He was not indisposed now to allow politely that a different course
of action might have been on the whole better. But to submit
his deeds to the judgment of Hermione was another matter. If she had
excused him, he would have blamed himself—moderately. Since she
blamed him, he stood upon the defensive.</p>
<p class="calibre3">There is a right and a wrong in all things, sometimes absolute and
intrinsic, sometimes proportionate and relative. Some deeds are right
or wrong always, in all places, for all people. Other deeds are right
or wrong according to circumstances, and may at the self-same time
be right for this person, wrong for that person.</p>
<p class="calibre3">Hermione, earnest, conscientious, decisive, saw plainly the bald fact
of right being right, and wrong being wrong. Harvey, not half
so conscientious, not half so earnestly bent upon doing the right,
knew practically far more than did Hermione of the possible
perplexities which may and do arise in connection with this
ever-recurring question. But he knew also, if only he would have
allowed it to himself, that there had been no such perplexity
connected with the subject lately discussed.</p>
<p class="calibre3">So much for Harvey's train of thought as the trio walked the terrace
side by side. Hermione's ran on a parallel line, being chiefly
occupied with him. She was not grieved after the fashion of Marjory
Fitzalan, for Hermione's was not, like Marjory's, a hero-worshipping
nature. If Hermione worshipped any human being at all, it was all
unconsciously her most sweet and attractive self. But then,
of course, it was unconsciously. Other people she looked upon with a
calm and gentle kindness, ready to administer praise, blame,
or advice, as might be called for. Why not? Hermione was accustomed
to find her praise welcomed, her blame submitted to, her advice
followed. Almost everybody in her little world looked up to her,
as Marjory had said.</p>
<p class="calibre3">It was a somewhat unwonted position for a girl of her age, enhanced
by her extreme prettiness—not altogether a safe or wholesome
position.</p>
<p class="calibre3">Mr. Dalrymple's train of thought was less definite than that
of either of his companions. For he was grieving still over his
shattered dream, grieving yet more over his unconquered wilfulness,
and struggling against an unwonted sense of inertia and weariness.
He wished to be kind and chatty with his great-nephew, but it was not
easy.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?26e334c2